import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["newBadge"]
  static values = {
    fileModified: String
  }

  connect() {
    this.modalId = "#changelog-modal"
    this.checkIfAlreadyViewed()
  }

  checkIfAlreadyViewed() {
    // If no badge target, nothing to hide
    if (!this.hasNewBadgeTarget) return

    // If no file modified date, can't compare
    if (!this.hasFileModifiedValue) return

    try {
      const lastViewed = localStorage.getItem("changelog_last_viewed")

      // If user never viewed, show badge
      if (!lastViewed) return

      // Compare dates: if user viewed after last file modification, hide badge
      const lastViewedDate = new Date(lastViewed)
      const fileModifiedDate = new Date(this.fileModifiedValue)

      if (lastViewedDate >= fileModifiedDate) {
        this.newBadgeTarget.classList.add("hidden")
      }
    } catch (error) {
      console.error("Error checking changelog viewed status:", error)
      // On error, show badge (fail-safe)
    }
  }

  async toggle(event) {
    event.preventDefault()

    const modal = document.querySelector(this.modalId)
    if (!modal) {
      console.error("Changelog modal not found")
      return
    }

    const isHidden = modal.classList.contains("hidden")

    if (isHidden) {
      this.openModalViaGlobalController()
      await this.loadChangelog()
      this.markAsViewed()
    } else {
      this.closeModalViaGlobalController(modal)
    }
  }

  openModalViaGlobalController() {
    const modalController = this.application.getControllerForElementAndIdentifier(document.body, 'modal')
    if (modalController) {
      const syntheticEvent = {
        preventDefault: () => {},
        params: { targetParam: this.modalId }
      }
      modalController.open(syntheticEvent)
    }
  }

  closeModalViaGlobalController(modal) {
    const modalController = this.application.getControllerForElementAndIdentifier(document.body, 'modal')
    if (modalController) {
      modalController.closeModal(modal)
    }
  }

  async loadChangelog() {
    try {
      const response = await fetch("/changelog/summary", {
        headers: {
          "Accept": "text/vnd.turbo-stream.html"
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const turboStreamHtml = await response.text()
      Turbo.renderStreamMessage(turboStreamHtml)
    } catch (error) {
      console.error("Error loading changelog:", error)
    }
  }

  markAsViewed() {
    if (this.hasNewBadgeTarget) {
      this.newBadgeTarget.classList.add("hidden")
    }

    try {
      localStorage.setItem("changelog_last_viewed", new Date().toISOString())
    } catch (error) {
      console.error("Failed to save changelog view timestamp:", error)
    }
  }
}
